import $ from 'jquery';

$.addInit(function(context){
	function getOffset(elem) {
		var offsetLeft = 0;
		var offsetTop = 0;
		do {
				if ( !isNaN( elem.offsetLeft ) ) {
				offsetLeft += elem.offsetLeft;
				offsetTop += elem.offsetTop;
			}
		} while( elem = elem.offsetParent );
		return {left: offsetLeft, top: offsetTop};
	}

	var targets = document.querySelectorAll( '[rel=tooltip]' );
	var target  = false;
	var tooltip = false;
	var title   = false;
	var tip     = false;

	for(var i = 0; i < targets.length; i++) {
		targets[i].addEventListener("mouseenter", function() {
			target  = this;
			tip     = target.getAttribute("title");
			tooltip = document.createElement("div");
			tooltip.className = "b-tooltip";

			if(!tip || tip == "")
				return false;

			target.removeAttribute("title");
			tooltip.style.opacity = 0;
			tooltip.innerHTML = tip;
			document.body.appendChild(tooltip);

			var initTooltip = function() {
				if(window.innerWidth < tooltip.offsetWidth * 1.5) {
					tooltip.style.maxWidth = window.innerWidth / 2;
				} else {
					tooltip.style.maxWidth = 340;
				}

				var posLeft = getOffset(target).left + (target.offsetWidth / 2) - (tooltip.offsetWidth / 2);
				var posTop = getOffset(target).top - tooltip.offsetHeight - 10;
				
				if( posLeft < 0 ) {
					posLeft = getOffset(target).left + target.offsetWidth / 2 - 20;
					tooltip.classList.add("m-left");
				} else {
					tooltip.classList.remove("m-left");
				}

				if( posLeft + tooltip.offsetWidth > window.innerWidth ) {
					posLeft = getOffset(target).left - tooltip.offsetWidth + target.offsetWidth / 2 + 20;
					tooltip.classList.add("m-right");
				}	else {
					tooltip.classList.remove("m-right");
				}

				if( posTop < 0 ) {
					var posTop  = getOffset(target).top + target.offsetHeight + 15;
					tooltip.classList.add("m-top");
				} else {
					tooltip.classList.remove("m-top");
					tooltip.style.left = posLeft + "px";
					tooltip.style.top = posTop + "px";
					tooltip.style.opacity  = 1;
				}
			};

			initTooltip();
			window.addEventListener("resize", initTooltip);

			var removeTooltip = function() {
				tooltip.style.opacity  = 0;
				document.querySelector(".b-tooltip") && document.body.removeChild(document.querySelector(".b-tooltip"));
				target.setAttribute("title", tip );
			};

			target.addEventListener("mouseleave", removeTooltip );
			tooltip.addEventListener("click", removeTooltip );
		});
	}
});


//////////////////
// WEBPACK FOOTER
// ./src/components/b-tooltip.js
// module id = 53
// module chunks = 0